module.exports = __webpack_public_path__ + "static/media/1s_background.11952c5d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/backgrounds/1s_background.jpg
// module id = 2586
// module chunks = 0